define('SearchModules.View', [
	'searchmodules.tpl',

	// 'Utils',
	'Backbone',
	// 'jQuery',
	// 'underscore',
], function (
	searchmodules_tpl,

	// Utils,
	Backbone,
	// jQuery,
	// _
) {
	'use strict';

	return Backbone.View.extend({
		template: searchmodules_tpl,

		// initialize: function () {},

		// events: {},

		// bindings: {},

		// childViews: {},

		// getContext: function getContext() {},
	});
});
